module.exports = __webpack_public_path__ + "static/media/BadgeAndroid.91d04765.png";